import { render, staticRenderFns } from "./DivisaoForm.vue?vue&type=template&id=7ebf1c94&lang=html"
import script from "./DivisaoForm.vue?vue&type=script&lang=js"
export * from "./DivisaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports